(function () {
  async function rankCollection(root) {
    const sourcePath = root.dataset.plBestsellerCollection;
    const label = root.dataset.plBestsellerLabel;
    if (!sourcePath || !label) return;
    const sourceUrl = new URL(sourcePath, window.location.origin);
    const cacheKey = 'pl-bestsellers-quarter-v1:' + sourceUrl.pathname;
    let handles;
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.saved < 900000 && Array.isArray(cached.handles)) handles = cached.handles;
    } catch (error) {}
    if (!handles) {
      sourceUrl.searchParams.set('view', 'printlits-bestsellers');
      sourceUrl.searchParams.set('sort_by', 'best-selling');
      let nextUrl = sourceUrl;
      const ranked = [];
      const seen = new Set();
      let limit = Infinity;
      while (nextUrl && ranked.length < limit) {
        const response = await fetch(nextUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Bestseller ranking unavailable');
        const data = await response.json();
        if (!Number.isSafeInteger(data.total) || data.total < 0 || !Array.isArray(data.handles)) throw new Error('Invalid bestseller ranking');
        limit = Math.ceil(data.total / 4);
        for (const handle of data.handles) {
          if (typeof handle !== 'string' || seen.has(handle) || ranked.length >= limit) continue;
          seen.add(handle);
          ranked.push(handle);
        }
        nextUrl = data.next ? new URL(data.next, sourceUrl) : null;
        if (nextUrl && nextUrl.origin !== window.location.origin) throw new Error('Invalid ranking page');
      }
      handles = ranked;
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ saved: Date.now(), handles })); } catch (error) {}
    }
    const top = new Set(handles);
    root.querySelectorAll('.pc-card[data-product-handle]').forEach(function (card) {
      const oldBadge = card.querySelector('.pc-badge--bestseller');
      if (oldBadge) oldBadge.remove();
      if (!top.has(card.dataset.productHandle) || card.classList.contains('is-sold-out')) return;
      const image = card.querySelector('.pc-image-wrap');
      if (!image || image.querySelector('.pc-badge')) return;
      const badge = document.createElement('span');
      badge.className = 'pc-badge pc-badge--bestseller';
      badge.textContent = label;
      image.prepend(badge);
    });
  }
  function initialise() {
    document.querySelectorAll('[data-pl-bestseller-collection]').forEach(function (root) {
      rankCollection(root).catch(function (error) { console.warn('Printlits bestseller ranking could not load.', error); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
